module.exports = __webpack_public_path__ + "img/ioniq5-25.23cc6cbe.png";